export default class Annotation {
    type: string | null;
    value: any;
    isSelected: boolean;
  
    constructor(init?: { type?: string; value?: any }) {
      this.isSelected = false;
  
      if (init) {
        this.type = init.type ?? null;
        this.value = init.value ?? null;
      } else {
        this.type = null;
        this.value = null;
      }
    }
  }
  